if (document.getElementById('AjaxinatePagination')){



  
  var advance = function advance() {
    if(typeof quickAddButton == 'function'){
      quickAddButton();
    }
    if(typeof bindQuickViewButtons == 'function'){
      bindQuickViewButtons();
    } 
    
    if(typeof quickproductrow == 'function'){
      quickproductrow();
    }
    
    if(typeof productrow == 'function'){
      productrow();
    }
  }
  var infinitescroll = {
  scolljs: function(){
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      method: 'scroll',
      loadingText: document.getElementById('AjaxinatePagination').dataset.text,
      callback: advance,
      //offset: 200,
    });
  }
}
  infinitescroll.scolljs();
  document.addEventListener('scroll', function(e) {
    var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
    sessionStorage.scrollPos = document.documentElement.scrollTop;
    sessionStorage.totalpage = totalpage;
  });

// View toggle — navigate product image swipers to the correct slide
function syncViewToggle() {
  const productRadio = document.getElementById('product-view');
  const modelRadio = document.getElementById('model-view');
  if (!productRadio && !modelRadio) return;

  const targetView = modelRadio && modelRadio.checked ? 'model-view' : 'product-view';

  document.querySelectorAll('.product-images.swiper-initialized').forEach(function(el) {
    if (!el.swiper) return;
    const realSlides = el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
    let targetIndex = -1;
    realSlides.forEach(function(slide, i) {
      if (slide.dataset.view === targetView) targetIndex = i;
    });
    if (targetIndex >= 0) {
      el.swiper.slideToLoop(targetIndex, 0);
    }
  });
}

['product-view', 'model-view'].forEach(function(id) {
  const radio = document.getElementById(id);
  if (radio) radio.addEventListener('change', syncViewToggle);
});


  
  // var infinitescroll = {
  //   scolljs: function(){
  //     var endlessScroll = new Ajaxinate({
  //       container: '#product-grid',
  //       pagination: '#AjaxinatePagination',
  //       loadingText: document.getElementById('AjaxinatePagination').dataset.text,
  //       callback: advance,
  //       //offset: 200
  //     });
  //   }
  // }
  // infinitescroll.scolljs();
  // document.addEventListener('scroll', function(e) {
  // 	var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
	// sessionStorage.scrollPos = document.documentElement.scrollTop;
	// sessionStorage.totalpage = totalpage;
  // });
  // if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
	// var scrollTop=sessionStorage?.getItem('scrollPos')
	// document.documentElement.scrollTop = scrollTop ??  document.body.scrollTop;
  //   window.scrollTo(0,0);
	// scrollManualy(scrollTop);
	// function scrollManualy(scrollTop){
	// 	scrollTop = parseInt(scrollTop);
	// 	window.scrollTo(0,scrollTop)
 	// 	setTimeout(function(){
	// 		if(window.scrollY < scrollTop){
	// 			scrollManualy(scrollTop)
	// 		}
	// 	},1000);
	//  }
  // }
}


window.addEventListener('scroll', function() {
  const filter = document.querySelector('.snippet-collection-filter');
  if (filter) {
    const filterTop = filter.getBoundingClientRect().top;
    if (filterTop < 5) {
      document.body.classList.add('sticky-filter');
    } else {
      document.body.classList.remove('sticky-filter');
    }
  }
});




